export const initialPayload = {
  code: 0,
  message: 'look what I got!'
}

export default (type, payload = initialPayload) => ({
  type,
  payload
})
